var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"icon",on:{"click":() => {
      _vm.download(_vm.Id);
    }}},[_vm._v("mdi-arrow-down-bold")])
}
var staticRenderFns = []

export { render, staticRenderFns }